import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import "swiper/css";
import HelpIcon from "@mui/icons-material/HelpOutlined";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Divider from "@mui/material/Divider";
import HistoryIcon from "@mui/icons-material/History";
import LogoutIcon from "@mui/icons-material/Logout";
import LanguageIcon from "@mui/icons-material/Language";
import AccountBox from "@mui/icons-material/AccountBox";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setBahasaOpen } from "../../../redux/actions";
import Lotties from "../../../components/Lotties";
import GroupLottie from "../../../assets/lottie/group.json";
type Props = {
  stateUser: any;
  stateBahasa: string;
  actSetBahasaOpen: any;
  open: boolean;
  setopen: (open: boolean) => void;
};

const drawerItems = [
  {
    icon: <LockOpenIcon fontSize="small" />,
    title: {
      idn: "Login / Register",
      eng: "Login / Register",
    },
    action: "/login",
  },
  {
    icon: <HelpIcon fontSize="small" />,
    title: {
      idn: "Bantuan",
      eng: "Help",
    },
    action: "/faq",
  },
  {
    icon: <HelpIcon fontSize="small" />,
    title: {
      idn: "KIOSK",
      eng: "KIOSK",
    },
    action: "/splash-kios",
  },
];

const drawerItemsAuth = [
  {
    icon: <AccountBox fontSize="small" />,
    title: {
      idn: "Profile",
      eng: "Profile",
    },
    action: "/profile",
  },
  {
    icon: <HistoryIcon fontSize="small" />,
    title: {
      idn: "Riwayat",
      eng: "History",
    },
    action: "/history",
  },
  {
    icon: <HelpIcon fontSize="small" />,
    title: {
      idn: "Bantuan",
      eng: "Help",
    },
    action: "/faq",
  },
  {
    icon: <LogoutIcon fontSize="small" />,
    title: {
      idn: "Logout",
      eng: "Logout",
    },
    action: "/logout",
  },
];

const DrawerMenu = (props: Props) => {
  const { stateUser, stateBahasa, open, setopen, actSetBahasaOpen } = props;
  const navigate = useNavigate();

  return (
    <>
      <Drawer anchor="right" open={open} onClose={() => setopen(!open)}>
        <Box
          sx={{ width: "64vw" }}
          role="presentation"
          // onClick={() => setOpenDrawer(!openDrawer)}
          // onKeyDown={() => setOpenDrawer(!openDrawer)}
        >
          <Container
            sx={{
              padding: "16px 0",
            }}
          >
            <Stack
              spacing={2}
              justifyContent="center"
              display="flex"
              alignItems="center"
            >
              <Box
                sx={{
                  // backgroundColor: "#000",
                  width: "70px",
                  height: "70px !important",
                  margin: "32px",
                  borderRadius: "50%",
                }}
                onClick={() => navigate("/profile")}
              >
                <Lotties
                  file={GroupLottie}
                  height="70px"
                  width="70px"
                  loop={true}
                />
              </Box>
              <Typography variant="body1" align="center">
                {stateUser.nama}
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
              >
                <List>
                  {stateUser &&
                    drawerItemsAuth.map((item, index) => {
                      return (
                        <>
                          <ListItem disablePadding key={"drawerItem_" + index}>
                            <ListItemButton
                              onClick={() => navigate(item.action)}
                            >
                              <ListItemIcon>{item.icon}</ListItemIcon>
                              <ListItemText
                                primary={
                                  stateBahasa === "indonesia"
                                    ? item.title.idn
                                    : item.title.eng
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                        </>
                      );
                    })}
                  {!stateUser &&
                    drawerItems.map((item, index) => {
                      return (
                        <>
                          <ListItem disablePadding key={"drawerItem2_" + index}>
                            <ListItemButton
                              onClick={() => navigate(item.action)}
                            >
                              <ListItemIcon>{item.icon}</ListItemIcon>
                              <ListItemText
                                primary={
                                  stateBahasa === "indonesia"
                                    ? item.title.idn
                                    : item.title.eng
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                          <Divider />
                        </>
                      );
                    })}
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => actSetBahasaOpen(true)}>
                      <ListItemIcon>
                        <LanguageIcon />
                      </ListItemIcon>
                      <ListItemText
                        primary={
                          stateBahasa === "indonesia" ? "Bahasa" : "Language"
                        }
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              </Box>
            </Stack>
            <Box
              position="absolute"
              bottom="16px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
              onClick={() => navigate("/kelahiran")}
            >
              <Typography variant="body1" align="center">
                &copy;SIM RSUD Cengkareng
              </Typography>
            </Box>
          </Container>
        </Box>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    stateUser: state.auth.user,
    stateBahasa: state.app.bahasa,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actSetBahasaOpen: (body: any) => dispatch(setBahasaOpen(body)),
    // actResetAppointment: (body) => dispatch(resetAppointment(body)),
    // actGetPaketMCU: (body) => dispatch(getPaketMCU(body)),
    // actSetAppointment: (body) => dispatch(setAppointment(body)),
    // actSetTipeAppointment: (body) => dispatch(setTipeAppointment(body)),
    // actGetHistoryAppointment: (body, action) =>
    //   dispatch(getHistoryAppointment(body, action)),
    // actGenerateBillingMT: (body, navigator) =>
    //   dispatch(generateBillingMT(body, navigator)),
    // actFindMaintenance: (action) => dispatch(findMaintenance(action)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawerMenu);
